import { render } from "./CustomerGroups.vue?vue&type=template&id=be5ec4e6"
import script from "./CustomerGroups.vue?vue&type=script&lang=ts"
export * from "./CustomerGroups.vue?vue&type=script&lang=ts"
script.render = render

export default script